import React from 'react';

import { FormStepStyles } from './FormStep.styles';
import { FormStepMode, FormStepProps } from '@epi-models/pages/Transfer';

export const FormStep = ({
  mode = FormStepMode.Contained,
  children,
  stepNumber
}: FormStepProps) => {
  return (
    <FormStepStyles.Container
      id={`deposit_money_topup_step_${stepNumber}`}
      mode={mode}
    >
      {children}
    </FormStepStyles.Container>
  );
};
